/**
 * @description
 * Primary color of the application.
 */

export const PRIMARY_COLOR = '#001E5F';
export const APP_BACKGROUND_COLOR = '#F2F4F8';
export const ERROR_BACKGROUND_COLOR = '#C4C6CC';
